import {
    getDropshipSettingService,
    upsertDropshipSettingService,
    listProductForDropshipService,
    updateDropshipProductService,
    getMyListedProductsService,
    getMyListedProductIdsService,
    getDropshipProductHistoryService,
    getDropshipCatalogService,
    getDropshipCatalogDetailService,
    importDropshipProductService,
    getDropshipAgreementsService,
    updateDropshipAgreementService,
    getSupplierOrdersService,
    updateFulfillmentService,
    getDropshipMarginConfigService,
    upsertDropshipMarginConfigService,
    deleteDropshipMarginConfigService,
} from '../../services/dropship.service';

// ── Action Types ──────────────────────────────────────────────────────────────

// Settings
export const DROPSHIP_SETTING_SUCCESS = 'DROPSHIP_SETTING_SUCCESS';
export const DROPSHIP_SETTING_FAIL = 'DROPSHIP_SETTING_FAIL';
export const DROPSHIP_SETTING_LOADING = 'DROPSHIP_SETTING_LOADING';
export const DROPSHIP_UPSERT_SUCCESS = 'DROPSHIP_UPSERT_SUCCESS';

// My Listed Products (Day 3)
export const FETCH_MY_LISTED_PRODUCTS_PENDING = 'FETCH_MY_LISTED_PRODUCTS_PENDING';
export const FETCH_MY_LISTED_PRODUCTS_SUCCESS = 'FETCH_MY_LISTED_PRODUCTS_SUCCESS';
export const FETCH_MY_LISTED_PRODUCTS_FAILED = 'FETCH_MY_LISTED_PRODUCTS_FAILED';

// Listed-product lookup for the inventory-grid differentiator icon
export const FETCH_MY_LISTED_IDS_SUCCESS = 'FETCH_MY_LISTED_IDS_SUCCESS';
export const FETCH_MY_LISTED_IDS_FAILED = 'FETCH_MY_LISTED_IDS_FAILED';

// Dropship listing change history
export const FETCH_DROPSHIP_HISTORY_PENDING = 'FETCH_DROPSHIP_HISTORY_PENDING';
export const FETCH_DROPSHIP_HISTORY_SUCCESS = 'FETCH_DROPSHIP_HISTORY_SUCCESS';
export const FETCH_DROPSHIP_HISTORY_FAILED = 'FETCH_DROPSHIP_HISTORY_FAILED';

// Catalog (Day 4)
export const FETCH_DROPSHIP_CATALOG_PENDING = 'FETCH_DROPSHIP_CATALOG_PENDING';
export const FETCH_DROPSHIP_CATALOG_SUCCESS = 'FETCH_DROPSHIP_CATALOG_SUCCESS';
export const FETCH_DROPSHIP_CATALOG_FAILED = 'FETCH_DROPSHIP_CATALOG_FAILED';

// Agreements (Day 5)
export const FETCH_DROPSHIP_AGREEMENTS_PENDING = 'FETCH_DROPSHIP_AGREEMENTS_PENDING';
export const FETCH_DROPSHIP_AGREEMENTS_SUCCESS = 'FETCH_DROPSHIP_AGREEMENTS_SUCCESS';
export const FETCH_DROPSHIP_AGREEMENTS_FAILED = 'FETCH_DROPSHIP_AGREEMENTS_FAILED';

// Supplier Orders (Day 6)
export const FETCH_SUPPLIER_ORDERS_PENDING = 'FETCH_SUPPLIER_ORDERS_PENDING';
export const FETCH_SUPPLIER_ORDERS_SUCCESS = 'FETCH_SUPPLIER_ORDERS_SUCCESS';
export const FETCH_SUPPLIER_ORDERS_FAILED = 'FETCH_SUPPLIER_ORDERS_FAILED';

// 3PL Margin Config
export const FETCH_MARGIN_CONFIG_PENDING = 'FETCH_MARGIN_CONFIG_PENDING';
export const FETCH_MARGIN_CONFIG_SUCCESS = 'FETCH_MARGIN_CONFIG_SUCCESS';
export const FETCH_MARGIN_CONFIG_FAILED = 'FETCH_MARGIN_CONFIG_FAILED';

// ── Settings ──────────────────────────────────────────────────────────────────

export const getDropshipSetting = (data) => (dispatch) => {
    dispatch({ type: DROPSHIP_SETTING_LOADING });
    return getDropshipSettingService(data).then(
        (response) => {
            const setting = response.data?.EntityList?.[0] || null;
            dispatch({ type: DROPSHIP_SETTING_SUCCESS, payload: setting });
            return setting;
        },
        (error) => {
            dispatch({ type: DROPSHIP_SETTING_FAIL });
            throw error;
        }
    );
};

export const upsertDropshipSetting = (data) => (dispatch) => {
    return upsertDropshipSettingService(data).then(
        (response) => {
            const setting = response.data?.EntityList?.[0] || null;
            dispatch({ type: DROPSHIP_UPSERT_SUCCESS, payload: setting });
            return setting;
        },
        (error) => {
            throw error;
        }
    );
};

// ── Day 3: Product Listing ────────────────────────────────────────────────────

export const listProductForDropship = (data) => {
    return listProductForDropshipService(data);
};

export const updateDropshipProduct = (data) => {
    return updateDropshipProductService(data);
};

export const getMyListedProducts = (data) => (dispatch) => {
    dispatch({ type: FETCH_MY_LISTED_PRODUCTS_PENDING });
    return getMyListedProductsService(data).then(
        (result) => {
            dispatch({
                type: FETCH_MY_LISTED_PRODUCTS_SUCCESS,
                payload: {
                    list: result.data?.EntityList || [],
                    totalRecords: result.data?.TotalRecords || 0,
                },
            });
            return result;
        },
        (error) => {
            dispatch({ type: FETCH_MY_LISTED_PRODUCTS_FAILED });
            throw error;
        }
    );
};

// Lightweight set of products the seller has already listed — used to switch the
// inventory-grid icon and to pre-fill the edit modal without a second fetch.
export const getMyListedProductIds = (data) => (dispatch) => {
    return getMyListedProductIdsService(data).then(
        (result) => {
            dispatch({
                type: FETCH_MY_LISTED_IDS_SUCCESS,
                payload: { list: result.data?.EntityList || [] },
            });
            return result;
        },
        (error) => {
            dispatch({ type: FETCH_MY_LISTED_IDS_FAILED });
            throw error;
        }
    );
};

// Change history for the seller's dropship listings (Dropshipping Settings page).
export const getDropshipProductHistory = (data) => (dispatch) => {
    dispatch({ type: FETCH_DROPSHIP_HISTORY_PENDING });
    return getDropshipProductHistoryService(data).then(
        (result) => {
            dispatch({
                type: FETCH_DROPSHIP_HISTORY_SUCCESS,
                payload: {
                    list: result.data?.EntityList || [],
                    totalRecords: result.data?.TotalRecords || 0,
                },
            });
            return result;
        },
        (error) => {
            dispatch({ type: FETCH_DROPSHIP_HISTORY_FAILED });
            throw error;
        }
    );
};

// ── Day 4: Catalog ────────────────────────────────────────────────────────────

export const getDropshipCatalog = (data) => (dispatch) => {
    dispatch({ type: FETCH_DROPSHIP_CATALOG_PENDING });
    return getDropshipCatalogService(data).then(
        (result) => {
            dispatch({
                type: FETCH_DROPSHIP_CATALOG_SUCCESS,
                payload: {
                    list: result.data?.EntityList || [],
                    totalRecords: result.data?.TotalRecords || 0,
                },
            });
            return result;
        },
        (error) => {
            dispatch({ type: FETCH_DROPSHIP_CATALOG_FAILED });
            throw error;
        }
    );
};

export const getDropshipCatalogDetail = (data) => {
    return getDropshipCatalogDetailService(data);
};

// ── Day 5: Import & Agreements ────────────────────────────────────────────────

export const importDropshipProduct = (data) => {
    return importDropshipProductService(data);
};

export const getDropshipAgreements = (data) => (dispatch) => {
    dispatch({ type: FETCH_DROPSHIP_AGREEMENTS_PENDING });
    return getDropshipAgreementsService(data).then(
        (result) => {
            dispatch({
                type: FETCH_DROPSHIP_AGREEMENTS_SUCCESS,
                payload: {
                    list: result.data?.EntityList || [],
                    totalRecords: result.data?.TotalRecords || 0,
                },
            });
            return result;
        },
        (error) => {
            dispatch({ type: FETCH_DROPSHIP_AGREEMENTS_FAILED });
            throw error;
        }
    );
};

export const updateDropshipAgreement = (data) => {
    return updateDropshipAgreementService(data);
};

// ── Day 6: Fulfillment ────────────────────────────────────────────────────────

export const getSupplierOrders = (data) => (dispatch) => {
    dispatch({ type: FETCH_SUPPLIER_ORDERS_PENDING });
    return getSupplierOrdersService(data).then(
        (result) => {
            dispatch({
                type: FETCH_SUPPLIER_ORDERS_SUCCESS,
                payload: {
                    list: result.data?.EntityList || [],
                    totalRecords: result.data?.TotalRecords || 0,
                },
            });
            return result;
        },
        (error) => {
            dispatch({ type: FETCH_SUPPLIER_ORDERS_FAILED });
            throw error;
        }
    );
};

export const updateFulfillment = (data) => {
    return updateFulfillmentService(data);
};

// ── 3PL Margin Config ─────────────────────────────────────────────────────────

export const getDropshipMarginConfig = (data) => (dispatch) => {
    dispatch({ type: FETCH_MARGIN_CONFIG_PENDING });
    return getDropshipMarginConfigService(data).then(
        (result) => {
            dispatch({
                type: FETCH_MARGIN_CONFIG_SUCCESS,
                payload: {
                    list: result.data?.EntityList || [],
                },
            });
            return result;
        },
        (error) => {
            dispatch({ type: FETCH_MARGIN_CONFIG_FAILED });
            throw error;
        }
    );
};

export const upsertDropshipMarginConfig = (data) => {
    return upsertDropshipMarginConfigService(data);
};

export const deleteDropshipMarginConfig = (data) => {
    return deleteDropshipMarginConfigService(data);
};
